import { ImagePreview } from '@aigc/components';
import { useOverlay } from '@aigc/overlay-hook';
import { isAudio, isImage, isVideo } from '@aigc/toolkit';
import { type UploadProps } from 'antd';
import { useCallback } from 'react';

export const usePreviewFn = () => {
  const [openImagePreview] = useOverlay();

  const onPreview: UploadProps['onPreview'] = useCallback(
    (file) => {
      if (!file.url) {
        return;
      }

      if (!isImage(file.url) && !isVideo(file.url) && !isAudio(file.url)) {
        window.open(file.url, '_blank');
        return;
      }

      openImagePreview(<ImagePreview src={file.url}></ImagePreview>);
    },
    [openImagePreview],
  );

  return onPreview;
};
